<template>
	<div>
		<v-img
			alt="Tasko Logo"
			
			position="left"
			:src="CURRENT_LOGO"
			:height="height"
		/>
	</div>
	
</template>

<script>
import {mapGetters} from "vuex";
import {CURRENT_LOGO} from "@/store/getters";

export default {
	name: "AppLogo",
	props: {
		height: {
			default: '80%'
		}
	},
	computed: {
		...mapGetters([
			CURRENT_LOGO
		]),
	}
}
</script>


<style scoped>

</style>